$ = require('jquery')
l = require('app/scripts/lib/localize')

$.fn.format = (key, data) ->
  @text l(key, data, { raw: true })
  @

$.fn.formatHtml = (key, data) ->
  @html l(key, data)
  @
